import React, { useEffect } from 'react'
import ListComments from '../Utils/ListComments'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { STATUS } from '../../Constants';
import { useParams } from 'react-router-dom';
import { getAllCommentsOfPostAPI, getSpecificGroupData } from '../../RTK/Slice/SpecificGroup/SpecificGroupSlice';

const SpecificGroupPostComments = () => {

  // For Dispatch Action 
  const dispatch = useDispatch() ;

  // For Get Post Id
  const {postId} = useParams() ; 

  // For Get Active Token 
  const userToken = useSelector(getActiveToken);

  // For Get Toke 
  const token = useSelector(getToken) ; 

  // For Get All Comments
  useEffect(()=>{
    dispatch(getAllCommentsOfPostAPI({token , userToken , postId}))
  } , [postId]) ; 

  // For Access Comments 
  const {comments , statusOfComments} = useSelector(getSpecificGroupData);
    
  return (
    <div>
        <ListComments comments={comments} statusOfComments={statusOfComments} />
    </div>
  )
}

export default SpecificGroupPostComments
